import { render, staticRenderFns } from "./complyAdvantage.vue?vue&type=template&id=c3a34054&scoped=true&"
import script from "./complyAdvantage.vue?vue&type=script&lang=js&"
export * from "./complyAdvantage.vue?vue&type=script&lang=js&"
import style0 from "./../monitoring-differential-highlighter/monitoring-differential-highlighter.scss?vue&type=style&index=0&id=c3a34054&prod&scoped=true&lang=scss&"
import style1 from "./complyAdvantage.vue?vue&type=style&index=1&id=c3a34054&prod&scoped=true&lang=css&"
import style2 from "./complyAdvantage.vue?vue&type=style&index=2&id=c3a34054&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3a34054",
  null
  
)

export default component.exports